export default __webpack_public_path__ + "static/artifakt-element-bold-2537d1ca79fce1f5e9593c222da7948b.eot";